/**
 * Sort list of requests by priorities and creation date
 * @param a
 * @param b
 */
export const sortByPriorityAndDate = (a, b) => {
  return b.priority.id - a.priority.id || new Date(a.created_at) - new Date(b.created_at)
}